import React from "react";

import { NavigateCard } from "../../../components/cards";

import * as S from "./styles";

const ChooseRegisterType: React.FC = () => (
  <S.Container>
    <S.Title>
      Escolha uma opção para <br /> iniciar o seu cadastro
    </S.Title>
    <S.CardContainer>
      <NavigateCard icon="suit-guy" to="cadastrar-empresa/1">
        Já tenho CNPJ
      </NavigateCard>
      <NavigateCard icon="building" to="cadastro-basico/1" invertColor>
        Quero abrir a <br /> minha empresa
      </NavigateCard>
    </S.CardContainer>
  </S.Container>
);

export default ChooseRegisterType;
